"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayersWrapper = void 0;
const UiElements_1 = require("../ui/UiElements");
class LayersWrapper {
    constructor(className) {
        if (!className) {
            throw new Error("Class name is undefined");
        }
        this._container = this.create(className);
    }
    get container() { return this._container; }
    set container(container) { this._container = container; }
    create(className) {
        return new UiElements_1.DivEl()
            .setClass(className)
            .addChild(new UiElements_1.DivEl().setId('toastPlaceholder'));
    }
}
exports.LayersWrapper = LayersWrapper;
